import IAlert from "@/models/modelView/IAlert";
import FormatDate from "@/utils/date.util";
import EventStrategy from "./event.strategy";

export default class ModemEventStrategy extends EventStrategy {


    mapEvent(): IAlert {
        return {
            data: [
                {
                    title: 'Fecha:',
                    value: FormatDate.getGenericFormat(this.event.eventTime) 
                }
            ],
            ...this.eventBase()
        }
    }


}